<template>
  <div class="box" :style="[{
    position: styleInfo.slideEffect == 'suspension' && !navFree ? 'fixed' : 'relative',
  }, navThemeObject, activeTextObject, { '--main-color': themeColor }]">
    <div class="left-nav-collapse" v-if="styleInfo.layoutPos === 'left'" @click="$emit('collapse', !isCollapse)">
      <i class="iconfont icon-a-zhankai2" :class="isCollapse ? '' : 'rotate'" />
    </div>
    <div class="boxSon">
      <div class="above" :style="{
        backgroundColor: styleInfo.aboutColor,
        height: topData.list.above.h + 'px',
      }">
        <div class="inner-above" :style="{
          width: topData.list.above.w + 'px',
          height: topData.list.above.h + 'px',
        }">
          <div v-show="topData.list.above.list.leftText.show" ref="leftText" class="left-text" :style="{
            left: topData.list.above.list.leftText.x + 'px',
            top: topData.list.above.list.leftText.y + 'px',
            width: topData.list.above.list.leftText.w + 'px',
            height: topData.list.above.list.leftText.h + 'px',
          }">
            <span style="vertical-align: sub" :style="{
              color: topData.list.above.list.leftText.font.color,
              fontFamily: topData.list.above.list.leftText.font.fontFamily,
              fontSize: topData.list.above.list.leftText.font.fontSize,
              fontStyle: topData.list.above.list.leftText.font.fontStyle,
              textDecoration: topData.list.above.list.leftText.font.fontDec,
              fontWeight: topData.list.above.list.leftText.font.fontWeight,
              lineHeight: topData.list.above.list.leftText.h + 'px',
              textAlign: topData.list.above.list.leftText.font.textAlign,
            }">{{ topData.list.above.list.leftText.text }}</span>
          </div>
          <div v-if="topData.list.above.list.user.show" ref="user" class="user" :style="{
            left:topData.list.above.list.user.x + 'px',
            top: topData.list.above.list.user.y + 'px',
            height: topData.list.above.list.user.h + 'px',
          }">
            <div class="remind" v-if="!openWebsite" style="position: relative">
              <el-popover v-model="isPopValue" trigger="click" placement="bottom-end" popper-class="door-popper"
                transition="el-zoom-in-top">
                <template #reference>
                  <div v-if="openRole && !openWebsite && !upaceid" class="open-door" title="切换门户">
                    <i :style="{
                      color:
                        styleInfo.iconColor === 'deepColor' ? '#333' : '#FFF',
                    }" class="WSiconfont WSicon-tuimen2 open-door-img" v-if="rolesList.length > 1" />
                  </div>
                </template>
                <el-radio-group v-model="customId" @change="handleRadioChange"
                  style="display: flex; flex-wrap: wrap; flex-direction: column">
                  <el-radio style="width: 100%; color: #fff" v-for="item in rolesList" :key="item.customDeskId"
                    :label="'' + item.customDeskId">{{ item.name }}</el-radio>
                </el-radio-group>
              </el-popover>
              <schoolNews :openWebsite="openWebsite" v-if="!openWebsite" layout="2" :iconColor="styleInfo.iconColor === 'deepColor' ? '#333' : '#FFF'
                " />
            </div>
            <div class="userArea">
              <div class="userArea-toLogin" v-if="openWebsite && !sysUserMsg">
                <a @click="toLogin"
                  :style="[topData.list.above.list.user.font, { background: themeColor }, { color: '#fff' }]"
                  class="userArea-toLogin-btn">
                  {{ getLoginText }}
                </a>
              </div>
              <el-popover v-else placement="bottom-start" popper-class="userPopover" width="200" trigger="click"
                style="top: 35px !important">
                <!-- 前台工具栏 -->
                <div class="popoverArea" v-if="typeShow === 1">
                  <template v-if="openVip">
                    <template v-if="isVip">
                      <div class="vip-area" @click="goVipCenter">
                        <span class="tag">{{memberInfo.level}}会员</span>
                        <div class="time">剩余时长：<span>{{memberInfo.expireDate}}</span></div>
                      </div>
                      <p class="btn-vip" @click="goVip">续费/升级会员</p>
                    </template>
                    <p class="btn-vip" v-else @click="goVip">开通会员</p>
                  </template>
                  <p @click="goAccount">
                    账号管理
                  </p>
                  <p @click="$emit('open-admin')" v-if="adminload === 0 && sysUserMsg && sysUserMsg.isadmin < 3">
                    后台管理
                  </p>
                  <p @click="$emit('open-space')" v-if="spaceAppenComp">
                    组织空间
                  </p>
                  <p @click="$openAdmin({ path: '/cust/main/upaceMain' }, { isNewTab: true })" v-if="upaceAppen">
                    个人空间
                  </p>
                  <p @click="$emit('change-user')">
                    切换账号
                  </p>

                  <!-- <p
                    @click="
                      $router.push({
                        path: '/clientSide/setUpThe/changePassword',
                      })
                    "
                  >
                    修改密码
                  </p> -->
                  <!-- <p v-if="openRole" @click="showRoleDialog">切换门户</p> -->
                  <p @click="logout">退出账号</p>
                </div>
                <!-- 后台工具栏 -->
                <div class="popoverArea" v-if="typeShow === 2">
                  设置
                  <p @click="$router.push({ path: '/index' })">客户端查看</p>
                  <p @click="logout">退出登录</p>
                </div>
                <!-- 点击切换 -->
                <template #reference>
                  <div style="cursor: pointer">
                    <div class="name" :style="{
                      color: topData.list.above.list.user.font.color,
                      fontFamily: topData.list.above.list.user.font.fontFamily,
                      fontSize: topData.list.above.list.user.font.fontSize,
                      fontStyle: topData.list.above.list.user.font.fontStyle,
                      textDecoration: topData.list.above.list.user.font.fontDec,
                      fontWeight: topData.list.above.list.user.font.fontWeight,
                      lineHeight: topData.list.above.list.user.h + 'px',
                      textAlign: topData.list.above.list.user.font.textAlign,
                    }">
                      您好，{{ sysUserMsg.name }}！
                    </div>
                    <span v-if="openVip && isVip" class="tag">{{memberInfo.level}}</span>
                  </div>
                </template>
              </el-popover>
            </div>
          </div>
          <div v-show="topData.list.above.list.rightButton.show" class="right-button" ref="rightButton" @click="logout"
            :style="{
              left:topData.list.above.list.rightButton.x + 'px',
              top: topData.list.above.list.rightButton.y + 'px',
              width: topData.list.above.list.rightButton.w + 'px',
              height: topData.list.above.list.rightButton.h + 'px',
              color: topData.list.above.list.rightButton.font.color,
              fontFamily: topData.list.above.list.rightButton.font.fontFamily,
              fontSize: topData.list.above.list.rightButton.font.fontSize,
              fontStyle: topData.list.above.list.rightButton.font.fontStyle,
              textDecoration: topData.list.above.list.rightButton.font.fontDec,
              fontWeight: topData.list.above.list.rightButton.font.fontWeight,
              lineHeight: topData.list.above.list.rightButton.h + 'px',
              textAlign: topData.list.above.list.rightButton.font.textAlign,
            }">
            <span>{{ topData.list.above.list.rightButton.text }}</span>
          </div>
        </div>
      </div>
      <div class="middle" :style="{
        height: topData.list.middle.h + 'px',
        backgroundColor: styleInfo.middleColor,
      }">
        <div class="inner-middle" :style="{
          width: topData.list.middle.w + 'px',
          height: topData.list.middle.h + 'px',
        }">
          <div v-show="topData.list.middle.list.logo.show" class="logo" :style="{
            left:topData.list.middle.list.logo.x + 'px',
            top: topData.list.middle.list.logo.y + 'px',
            width: topData.list.middle.list.logo.w + 'px',
            height: topData.list.middle.list.logo.h + 'px',
          }" style="box-sizing: border-box" class-name-handle="handle">
            <div ref="logo-img" class="logo-img" v-if="topDataMideel.img.show" :style="{
              width: topDataMideel.img.w + 'px',
              height: topDataMideel.img.h + 'px',
            }" :class="topDataMideel.name.show || topDataMideel.slogan.show ? '' : 'boxAuto'">
              <el-image
                :src="topDataMideel.img.url.includes('http') ? topDataMideel.img.url : $url + topDataMideel.img.url"
                :fit="topDataMideel.img.fit">
              </el-image>
            </div>
            <div class="logo-text"
              v-if="topDataMideel.name.show || topDataMideel.slogan.show || (topDataMideel.subscript && topDataMideel.subscript.show)">
              <div v-if="topDataMideel.name.show || (topDataMideel.subscript && topDataMideel.subscript.show)">
                <span :style="topDataMideel.name.font" v-if="topDataMideel.name.show">{{ topDataMideel.name.text
                  }}</span>
                <span class="logo-subscript" v-if="topDataMideel.subscript && topDataMideel.subscript.show"
                  :style="topDataMideel.subscript && topDataMideel.subscript.font">{{ topDataMideel.subscript &&
                    topDataMideel.subscript.text }}</span>
              </div>
              <div v-if="topDataMideel.slogan.show">
                <span ref="logo-slogan" :style="topDataMideel.slogan.font">{{ topDataMideel.slogan.text }}</span>
              </div>
            </div>
          </div>
          <div class="switch" ref="switch" v-if="schoolList.length > 1" :style="{
            left:topData.list.middle.list.switch.x + 'px',
            top: topData.list.middle.list.switch.y + 'px',
            width: topData.list.middle.list.switch.w + 'px',
            height: topData.list.middle.list.switch.h + 'px',
          }" @click="changeSchool">
            <img style="height: 100%; width: 100%" :src="hadnleSwitch" />
          </div>
          <!-- 搜索框 -->
          <div class="inputArea" v-show="typeShow === 1 && topData.list.middle.list.search.show" :style="{
            left:topData.list.middle.list.search.x + 'px',
            top: topData.list.middle.list.search.y + 'px',
          }">
            <el-input placeholder="搜索应用" v-model="searchInput" clearable @keyup.enter="searchMoreFun">
              <template #prefix>
                <el-icon>
                  <Search />
                </el-icon>
              </template>
            </el-input>
            <el-button size="small" :style="{ background: themeColor, }" @click="searchMoreFun" type="primary">
              <i class="iconfont icon-sousuo"></i>
            </el-button>
          </div>
        </div>
      </div>
      <div class="below" ref="below" :style="topBgInfo"
        :class="topData.list.below.list.navbar.style"
        v-show="topData.list.below.list.navbar.show && styleInfo.layoutPos !== 'left'">
        <div class="navbox" ref="navbox" :style="{
          width: topData.list.below.list.navbar.w + 'px',
          height: topData.list.below.h + 'px',
        }">
          <div class="navbar-mask" ref="navbar-mask">
            <span v-show="topData.navbarIsScroll" class="back" @click="changeTab('left')"><i
                class="iconfont icon-fanhui1"></i></span>
            <ul ref="navbar" class="navbar" data-name="navbar" :class="topData.list.below.list.navbar.style"
              :style="topData.list.below.list.navbar.font">
              <template v-for="(item, i) in topData.list.below.list.navbar.list">
                <li v-if="item.isShow" :key="i"
                  :class="[item.id === activeTopMenu && !isNews ? `active ${styleInfo.navStyle || 'colorBlock'}` : '', `navbar-mask-li-${styleInfo.navStyle || 'colorBlock'}`, isAppenDrop(item) && styleInfo.childStyle === 'style1' ? 'arrow-top' : '']"
                  ref="column" class="navbar-mask-li" @mouseleave.self="mouseleave(i)" @mouseenter.self="mouseenter(i)">
                  <a href="javascript:;" @click="active(i, item)" @mouseover="mouseover(i)" @mouseout="mouseout(i)"
                    :style="styleObject">
                    {{ item.column }}
                  </a>
                  <div v-show="isAppenDrop(item)" @transitionend.self="transitionend" @mouseleave="mouseleave(i)"
                    @mouseenter="mouseNaventer(i)" class="navson-drop" :ref="`drop-${i}`"
                    :class="`drop-${styleInfo.childStyle}`">
                    <div class="navson-drop-item" :style="topData.list.below.list.navbar.font"
                      :class="citem.id === activeTopChildMenu ? 'active-nav navson-tile-item' : 'navson-tile-item'"
                      v-show="citem.isShow" @click="active(i, citem)" v-for="(citem, cidx) in item.lists" :key="cidx">
                      {{ citem.column }}
                    </div>
                  </div>
                </li>
              </template>
            </ul>
            <span v-show="topData.navbarIsScroll" class="next" @click="changeTab('right')"><i
                class="iconfont icon-qianjin"></i></span>
          </div>
        </div>
      </div>
      <div class="route" :style="{
        backgroundColor: styleInfo.routeColor,
        height: topData.list.route.h + 'px',
      }">
        <div class="inner-route" :style="{
          width: topData.list.route.w + 'px',
          height: topData.list.route.h + 'px',
        }">
          <div ref="route" v-show="topData.list.route.list.text.show" style="position: absolute" :style="{
            left: topData.list.route.list.text.x + 'px',
            top: topData.list.route.list.text.y + 'px',
            width: topData.list.route.list.text.w + 'px',
            height: topData.list.route.list.text.h + 'px',
            color: topData.list.route.font.color,
            fontFamily: topData.list.route.font.fontFamily,
            fontSize: topData.list.route.font.fontSize,
            fontStyle: topData.list.route.font.fontStyle,
            textDecoration: topData.list.route.font.fontDec,
            fontWeight: topData.list.route.font.fontWeight,
            lineHeight: topData.list.route.font.lineHeight,
            textAlign: topData.list.route.font.textAlign,
          }">
            {{ topData.list.route.title }}：{{ curPage }}
          </div>
        </div>
      </div>
    </div>
    <div ref="navson" class="navson"
      :class="topData.list.below.list.navbar.style !== 'tile-gradient' ? 'navson-one' : 'navson-two'"
      v-if="styleInfo.childDirection !== 'drop'" @mouseover="mouseover(columnIndex)" @mouseout="mouseout()"
      :style="topData.list.below.list.navbar.font">
      <ul @mouseover="mouseover(columnIndex)" @mouseout="mouseout()">
        <template v-for="(item, i) in topData.list.below.list.navbar.temArr">
          <li v-if="item.isShow" :key="i" :class="activeTopChildMenu === item.id ? 'active-nav' : ''">
            <a href="javascript:;" @click="active(i, item)" :style="styleObject">{{ item.column }}</a>
          </li>
        </template>
      </ul>
    </div>
    <app-dialog :dialogInfo="dialogInfo"></app-dialog>
    <vipPay v-model:isView="vipPayShow" />
  </div>
</template>

<script>
import navMixins from './navMixins';
export default {
  name: "layoutTwo",
  mixins: [navMixins],
  computed: {
    topDataMideel() {
      return this.topData.list.middle.list.logo.list
    },
  },
  watch: {
    contentInfo(newVal) {
      Object.assign(this.topData, newVal);
      this.setBg();
    },
    customId(val) {
      this.$emit('update:chooseRoleId', val)
    },
    chooseRoleId: {
      handler(val) {
        this.customId = val
      },
      immediate: true
    },
    checkObj: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.topData.list.below.list.navbar.list = val.list
        }
      },
    },
  },
  data() {
    return {
      // 浏览器宽度
      winWidth: null,
      // 导航背景
      topBgInfo: {
        backgroundImage: '',
        backgroundColor: ''
      },
      // 面包屑位置
      curPage: '首页',
      navCur: null,
      navbarPage: 1,
      columnIndex: 0,
      topData: {
        name: 'layout2',
        pageWidth: document.body.clientWidth,
        bgColor: '#4088F7',
        bgImg: '',
        isShowColumnManage: false,
        navbarIsScroll: false,
        listName: ['logo', 'name', 'slogan', 'navbar', 'search', 'user'],
        h: 175,
        list: {
          above: {
            h: 34,
            w: document.body.clientWidth * 0.625,
            bgColor: '#F9FAF9',
            list: {
              leftText: {
                show: true,
                element: '',
                text: '欢迎访问智慧中台',
                x: 0,
                y: 5,
                h: 24,
                w: 'auto',
                font: {
                  fontSize: '14px', // 字体大小
                  fontFamily: '微软雅黑', // 字体样式
                  fontWeight: 'normal', // 是否加粗
                  fontStyle: 'normal', // 是否斜体
                  textDecoration: 'none', // 是否下划线
                  color: '#333', // 选择的颜色
                  textAlign: 'center' // 位置排版
                }
              },
              user: {
                show: true,
                element: '',
                text: '你好，张三！',
                y: 5,
                x: document.body.clientWidth * 0.625 - 180 - 30,
                font: {
                  fontSize: '14px', // 字体大小
                  fontFamily: '微软雅黑', // 字体样式
                  fontWeight: 'normal', // 是否加粗
                  fontStyle: 'normal', // 是否斜体
                  textDecoration: 'none', // 是否下划线
                  color: '#333', // 选择的颜色
                  textAlign: 'center' // 位置排版
                }
              },
              rightButton: {
                show: true,
                element: '',
                text: '退出',
                h: 24,
                w: 'auto',
                y: 5,
                x: document.body.clientWidth * 0.625 - 33,
                font: {
                  fontSize: '14px', // 字体大小
                  fontFamily: '微软雅黑', // 字体样式
                  fontWeight: 'normal', // 是否加粗
                  fontStyle: 'normal', // 是否斜体
                  textDecoration: 'none', // 是否下划线
                  color: '#333', // 选择的颜色
                  textAlign: 'center' // 位置排版
                }
              }
            }
          },
          middle: {
            h: 62,
            w: document.body.clientWidth * 0.625,
            bgColor: '#FFF',
            list: {
              logo: {
                show: true,
                element: '',
                editModalShow: false,
                x: 0,
                h: 39,
                y: 10,
                w: 135,
                handles: ['br'],
                list: {
                  img: {
                    show: true,
                    h: 33,
                    w: 33,
                    url:
                      'https://bigdata.topeti.com/PCRepository/middleground/default-logo.png'
                  },
                  name: {
                    show: true,
                    text: '请输入标题',
                    element: '',
                    font: {
                      fontSize: '18px', // 字体大小
                      fontFamily: '微软雅黑', // 字体样式
                      fontWeight: 'normal', // 是否加粗
                      fontStyle: 'normal', // 是否斜体
                      textDecoration: 'none', // 是否下划线
                      color: '#333', // 选择的颜色
                      textAlign: 'center' // 位置排版
                    }
                  },
                  slogan: {
                    show: true,
                    text: '请输入简短说明',
                    element: '',
                    font: {
                      fontSize: '10px', // 字体大小
                      fontFamily: '微软雅黑', // 字体样式
                      fontWeight: 'normal', // 是否加粗
                      fontStyle: 'normal', // 是否斜体
                      textDecoration: 'none', // 是否下划线
                      color: '#333', // 选择的颜色
                      textAlign: 'center' // 位置排版
                    }
                  }
                }
              },
              switch: {
                // x轴偏移位置
                x: 135,
                // y轴偏移位置
                y: 22,
                // 高度
                h: 18,
                // 宽度
                w: 18,
                // 缩放的按钮显示
                handles: ['br']
              },
              search: {
                show: true,
                h: 30,
                w: 258,
                y: 12,
                x: document.body.clientWidth * 0.625 - 318,
                handles: ['br'],
                font: '',
                input: {
                  focusColor: ''
                },
                button: {
                  w: 60,
                  h: 32
                }
              }
            }
          },
          below: {
            h: 43,
            list: {
              navbar: {
                show: true,
                element: '',
                font: {
                  fontSize: '16px', // 字体大小
                  fontFamily: '微软雅黑', // 字体样式
                  fontWeight: 'normal', // 是否加粗
                  fontStyle: 'normal', // 是否斜体
                  textDecoration: 'none', // 是否下划线
                  color: '#FFF', // 选择的颜色
                  textAlign: 'center' // 位置排版
                },
                h: 43,
                w: document.body.clientWidth * 0.625,
                style: 'tile-gradient', // tile-gradient
                handles: ['br'],
                list: this.checkObj,
                temArr: []
              }
            }
          },
          route: {
            title: '当前位置',
            h: 34,
            bgColor: '#F9FAF9',
            w: document.body.clientWidth * 0.625,
            font: {
              fontSize: '14px', // 字体大小
              fontFamily: '微软雅黑', // 字体样式
              fontWeight: 'normal', // 是否加粗
              fontStyle: 'normal', // 是否斜体
              textDecoration: 'none', // 是否下划线
              color: '#333', // 选择的颜色
              textAlign: 'center' // 位置排版
            },
            list: {
              text: {
                x: 0,
                y: 5,
                show: true,
                element: '',
                w: 'auto',
                h: 19,
                arr: [0, 0]
              }
            }
          }
        }
      },
    };
  },
  methods: {
    back() {
      if (this.navbarPage === 1) return
      this.$refs.navbar.style.transform =
        'translateX(' +
        (this.$refs.column[this.navbarPage - 2].offsetWidth -
          Number(this.$refs.navbar.style.transform.replace(/[^0-9]/gi, ''))) +
        'px)'
      this.navbarPage--
    },
    next() {
      var tem = 0
      for (var i = 0; i < this.topData.list.below.list.navbar.list.length; i++) {
        if (this.topData.list.below.list.navbar.list[i].isShow) tem++
      }
      if (tem <= this.navbarPage) return
      this.$refs.navbar.style.transform =
        'translateX(-' +
        (Number(this.$refs.navbar.style.transform.replace(/[^0-9]/gi, '')) +
          this.$refs.column[this.navbarPage - 1].offsetWidth) +
        'px)'
      this.navbarPage++
    },
    mouseover(index) {
      if (this.styleInfo.childDirection === 'drop') return
      this.topData.list.below.list.navbar.temArr = []
      this.columnIndex = index
      if (this.topData.list.below.list.navbar.list[this.columnIndex].lists.length > 0) {
        if (index !== -1) {
          this.topData.list.below.list.navbar.temArr = this.topData.list.below.list.navbar.list[index].lists
        }
      } else return
      if (this.topData.list.below.list.navbar.style === 'tile-gradient') {
        const rect = this.$refs.navbar.getBoundingClientRect()
        this.$refs.navson.style.top = rect.top + rect.height + 'px'
        this.$refs.navson.style.height = '43px'
      } else {
        const rect = this.$refs.column[index].getBoundingClientRect()
        this.$refs.navson.style.maxHeight = '273px'
        this.$refs.navson.style.left = rect.left + 'px'
        this.$refs.navson.style.top = rect.top + rect.height + 'px'
      }
    },
    mouseout() {
      if (this.styleInfo.childDirection === 'drop') return
      if (this.topData.list.below.list.navbar.style === 'tile-gradient') {
        this.$refs.navson.style.height = '0px'
      } else {
        this.$refs.navson.style.maxHeight = '0px'
      }
    },
    // 初始化设置背景
    setBg() {
      const navData = this.topData.list.below.list.navbar.list;
      const pathName = window.location.pathname;
      for (let i = 0; i < navData.length; i++) {
        if (pathName === '/index' && navData[i].column === '首页' || pathName === '/clientSide/oaExamine' && navData[i].column === '应用中心' || pathName === '/clientSide/workbench' && navData[i].column === '发现') {
          this.navCur = i;
          this.curPage = navData[i].column;
          break;
        }
        else {
          this.navCur = 0;
          this.curPage = navData[0].column;
        }
      }
      this.winWidth = this.topData.pageWidth;
      if (Object.prototype.hasOwnProperty.call(this.styleInfo, 'backGroundInfo')) {
        switch (this.styleInfo.backGroundInfo.radio) {
          case "image":
            this.topBgInfo.backgroundImage = `url(${this.$url}${this.styleInfo.backGroundInfo.imageUrl})`
            this.topBgInfo.backgroundColor = '';
            break;
          case "color":
            this.topBgInfo.backgroundImage = '';
            this.topBgInfo.backgroundColor = this.topData.bgColor;
            break;
          default:
            this.topBgInfo.backgroundImage = '';
            this.topBgInfo.backgroundColor = '';
            break;
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.box {
  $main-color: var(--main-color);
  $navtheme-color: var(--navtheme-color);
  $activeText-color: var(--activeText-color);

  .userArea {
    &-toLogin {
      &-btn {
        padding: 8px 22px;
        cursor: pointer;
        border-radius: 8px;
      }
    }
  }

  .boxSon {
    .below {
      .navbox {
        .navbar-mask {
          .arrow-top {
            &:hover {
              &::after {
                opacity: 1;
              }
            }
          }

          .navbar-mask-li {
            padding: 0 50px;
            position: relative;

            a {
              background-color: initial;
              padding: 0;
              position: relative;
            }

            &::after {
              position: absolute;
              content: '';
              position: absolute;
              display: block;
              width: 0;
              height: 0;
              opacity: 0;
              top: calc(130% - 10px);
              left: calc(50% - 10px);
              transition: .3s;
              border-right: 10px solid transparent;
              border-bottom: 10px solid rgba(255, 255, 255, 0.8);
              ;
              border-left: 10px solid transparent;
            }

            .navson-drop {
              position: absolute;
              width: 100%;
              left: 0;
              transition: .3s;
              height: 0;
              overflow: hidden;

              &-item {
                box-sizing: border-box;
                padding: 12px 25px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #000;
                transition: .3s;
                cursor: pointer;
                font-weight: 400;
                font-size: 14px;
              }
            }

            .drop-style1 {
              top: 130%;
              background-color: rgba(255, 255, 255, 0.8);
              left: 50%;
              transform: translateX(-50%);
              max-width: 200%;
              width: initial;

              .navson-drop-item {
                color: #333 !important;

                &:hover {
                  background-color: $main-color;
                  color: $activeText-color !important;
                }
              }

              .active-nav {
                background-color: $main-color;
                color: $activeText-color !important;
              }
            }

            .drop-style2 {
              background-color: $main-color;

              .active-nav {
                background-color: #3333333d;
                color: $activeText-color;
              }

              .navson-drop-item {
                &:hover {
                  background-color: #3333333d;
                  color: $activeText-color;
                }
              }
            }
          }

          .navbar-mask-li-colorBlock {
            &:hover {
              background-color: $navtheme-color;
              color: $activeText-color;
            }
          }

          .colorBlock {
            background-color: $navtheme-color;
            color: $activeText-color;
          }

          .navbar-mask-li-underline {
            &:hover {
              color: $navtheme-color;

              a {
                position: relative;
                background-color: initial;
                color: $navtheme-color !important;
                padding: 0;
                width: 100%;
                text-align: center;

                &::after {
                  content: '';
                  position: absolute;
                  transform: translateX(-50%);
                  left: 50%;
                  width: 28px;
                  height: 3px;
                  bottom: 6px;
                  background-color: $navtheme-color;
                }
              }
            }
          }

          .underline {
            color: $navtheme-color;

            a {
              background-color: initial;
              color: $navtheme-color;
              padding: 0;
              width: 100%;
              text-align: center;

              &::after {
                content: '';
                position: absolute;
                transform: translateX(-50%);
                left: 50%;
                width: 28px;
                height: 3px;
                bottom: 6px;
                background-color: $navtheme-color;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.door-popper {
  background: #505050;
  border: none;

  .popper__arrow {
    border-bottom-color: #505050 !important;

    &::after {
      border-bottom-color: #505050 !important;
    }
  }
}
</style>
<style lang="scss" scoped>
$main-color: var(--main-color);

.box {
  position: relative;
  transition: all 0.3s;
  line-height: initial;
  width: 100%;
  z-index: 9;

  .left-nav-collapse {
    position: absolute;
    left: 20px;
    top: calc(50% - 13px);
    z-index: 99;
    height: 26px;
    padding-right: 32px;
    border-right: solid 1px #F0EFF2;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .icon-a-zhankai2 {
      font-size: 18px;
      color: #000000;
      cursor: pointer;
      display: inline-block;
      transition: .3s;
    }

    .rotate {
      transform: rotate(180deg);
    }
  }

  >div.vdr {
    position: relative;
    width: 100% !important;
    cursor: default;
  }
}

.pa {
  position: absolute;
}

.open-door {
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  left: -20px;
  top: 0;

  &-img {
    cursor: pointer;
    font-size: 24px;
  }
}

.above {
  position: relative;
  width: 100%;
  z-index: 9 !important;

  .inner-above {
    // position: relative;
    margin: 0 auto;

    .left-text {
      position: absolute;
      left: 0;
      top: 3px;
      color: #333333;
      font-size: 14px;
    }

    .user {
      position: absolute;
      color: #333333;
      font-size: 14px;
      left: 85%;
      top: 0;
      display: flex;
      width: 200px;

      .name {
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 24px;
        line-height: 24px;
      }

      .tag {
        display: inline-block;
        font-size: 14px;
        color: #E28A32;
        padding-left: 5px;
      }
    }

    .right-button {
      position: absolute;
      color: #333333;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
    }
  }
}

.logo-img {
  display: inline-block;
  vertical-align: top;

  // display: inline-flex;
  // align-items: center;
  // justify-content: center;
  ::v-deep .el-image {
    width: 100%;
    height: 100%;

    img {
      width: auto;
    }
  }
}

.logo {
  position: absolute;

  .logo-text {
    display: inline-block;
    margin-left: 4px;
    vertical-align: top;
    line-height: 18px;

    // margin-top: 8px;
    >div:first-child {
      color: #333333;
      font-size: 18px;
    }

    >div:last-child {
      color: #333333;
      font-size: 10px;
    }

    .logo-subscript {
      margin-left: 10px;
      padding: 5px 8px;
      border-radius: 8px 8px 8px 0;
      display: inline-block;
    }
  }
}

.switch {
  position: absolute;
  // background-image: url("https://bigdata.topeti.com/PCRepository/middleground/home/icon/header/switch-lightColor.svg");
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
}

.boxAuto {
  width: 100% !important;
  height: 100% !important;
}

.below {
  position: relative;
  background: #4088f7;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100% !important;
  z-index: 7 !important;

  .navbox {
    // position: relative;
    margin: 0 auto;
  }
}

.middle {
  position: relative;
  width: 100% !important;
  z-index: 8;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner-middle {
    // position: relative;
    margin: 0 auto;
  }
}

.route {
  width: 100% !important;

  .inner-route {
    // position: relative;
    margin: 0 auto;
  }
}

.inputArea {
  position: absolute;
  left: 65%;
  width: 258px;
  display: flex;
  align-items: center;
  line-height: 30px;

  ::v-deep .el-input__wrapper {
    border-radius: 4px 0 0 4px;
  }

  ::v-deep .el-button {
    width: 60px;
    height: 32px;
    background-color: #4e86ff;
    border: none;
    border-radius: 0 4px 4px 0;
    padding: 0;

    /*color: #ffffff;*/
    .iconfont {
      font-size: 24px;
    }
  }
}

.drop-pure.below {
  background-color: white;
}

div.below {
  border: none;
  position: relative;

  .navbox {
    position: relative;

    .navbar-mask {
      width: 100%;
      height: 100%;

      .navbar {
        transition: all 0.3s;
        white-space: nowrap;
        height: 100%;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #333333;
        display: inline-block;

        >li {
          display: inline-block;
        }
      }
    }

    span {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 50%;
      display: inline-block;
      background-color: rgba($color: #000000, $alpha: 0.3);
      width: 20px;
      height: 20px;
      cursor: pointer;
      z-index: 9;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        color: white;
        font-size: 10px;
      }
    }

    .back {
      left: -20px;
    }

    .next {
      right: -20px;
    }
  }
}

div.route.vdr {
  position: relative;
}

div.below>div.vdr {
  border: none;
}

.navbar>li:first-child {
  margin-left: 0;
}

.navbar>li {
  height: 100%;
  position: relative;
  border-right: 2px solid rgba($color: #fff, $alpha: 0.1);
  box-sizing: border-box;

  &:last-child {
    border: none;
  }
}

.navbar>li>ul {
  justify-content: center;
  align-items: center;
}

.navbar>li>a {
  color: inherit !important;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit !important;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
  padding: 0 50px;
  height: 100%;
  display: flex;
  transition: all 0.4s;
  justify-content: center;
  align-items: center;
}

.navbar.drop-gradient>li>a,
.navbar.tile-gradient>li>a {
  color: #fff;
}

.navbar.drop-gradient>li.active>a,
.navbar.drop-gradient>li:hover>a,
.navbar.tile-gradient>li.active>a,
.navbar.tile-gradient>li:hover>a {
  // background-color: var(--background-color);
  background-color: #3333333d;
}

.navbar.drop-pure>li.active>a,
.navbar.drop-pure>li:hover>a {
  color: #fff;
  background-color: #3333333d;
  // background-color: var(--background-color);
}

.navbar>li>ul {
  position: absolute;
  left: 0;
  white-space: nowrap;
  border-radius: 4px;
  background-color: white;
  max-height: 0;
  overflow: hidden;
  transition: all 0.6s;
  color: #333;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
}

.navbar>li.active a,
.navbar>li:hover ul {
  max-height: 400px;
}

.navbar.tile-gradient>li>ul {
  display: flex;
  width: 100%;
}

.navbar.tile-gradient>li {
  position: static;
}

.navbar>li>ul>li>a {
  display: block;
  padding: 10px 26px;
  background-color: white;
  transition: all 0.2s;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
}

.navbar>li>ul>li>a:hover {
  background-color: #4088f7;
  color: white;
}

.vdr.active>.tools {
  display: block;
}

div.below.vdr.active .tools {
  display: block;
}

div.logo div.vdr {
  position: static;
  border: none;
}

.navson {
  .active-nav {
    a {
      color: var(--background-color);
    }
  }
}

// 非通栏二级导航栏
.navson-one {
  max-height: 0px;
  transition: all 0.2s;
  position: absolute;
  background: #ffffff;
  border-radius: 4px;
  width: 120px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0 !important;
  }

  ul {
    li {
      width: 100%;

      a {
        display: inline-block;
        padding: 7px 0px;
        width: 80%;
        color: #333;
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        text-decoration: inherit;
        font-weight: inherit;
        line-height: inherit;
        text-align: inherit;
        transition: all 0.2s;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;

        &:hover {
          color: white;
        }
      }

      &:hover {
        background-color: #3333333d;
      }
    }
  }
}

// 通栏二级导航栏
.navson-two {
  height: 0px;
  transition: height 0.2s;
  position: absolute;
  background: #ffffff;
  left: 0px;
  width: 100%;
  overflow: hidden;

  ul {
    display: inline-block;
    text-align: center;
    height: 100%;

    li {
      display: inline-block;
      height: 100%;
      line-height: 41px;

      a {
        display: inline-block;
        height: 100%;
        padding: 0 25px;
        color: #333;
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        text-decoration: inherit;
        font-weight: inherit;
        line-height: inherit;
        text-align: inherit;
        transition: all 0.2s;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;

        &:hover {
          color: var(--background-color);
        }
      }
    }
  }
}

.news {
  width: 50px !important;
}

.popoverArea p {
  display: inline-block;
  width: 100%;
  text-align: center;
  height: 35px;
  line-height: 35px;
  cursor: pointer;

  &:hover {
    background-color: #f1f8ff;
  }
}

.popoverArea .vip-area {
  height: 85px;
  padding: 13px 0 0 14px;
  margin-bottom: 6px;
  box-sizing: border-box;
  border-radius: 6px;
  background: url("https://bigdata.topeti.com/PCRepository/mainPlatform/vip/bg-card.png") no-repeat 100% 100%;
  cursor: pointer;
  .tag {
    font-size: 16px;
    color: #E3782E;
  }

  .time {
    padding-top: 23px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #784928;

    span {
      padding-left: 10px;
      color: #FE6678;
    }
  }
}

.popoverArea .btn-vip {
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  font-size: 14px;
  color: #C36A2D;
  text-align: center;
  background: linear-gradient(270deg, rgba(255, 199, 106, 1) 0%, rgba(251, 218, 157, 1) 100%);
}
</style>
